module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Account-Creation_01-fb76a64e30e3dd61eeef7ba68812be8d.jpg";